import { Component } from '@angular/core';
import { UIActiveDialogService } from '../../../../shared/services/ui-dialog.service';
import { AssetAttachmentModel } from '../model/asset-attachment.model';

@Component({
  selector: 'asset-view-attachment-dialog',
  templateUrl:
    'console/app-js/modules/asset/components/asset-view-attachment-dialog/asset-view-attachment-dialog.component.html'
})
export class AssetAttachmentDialog {
  selectedIndex: number = 0;
  attachments: AssetAttachmentModel[];
  attachment: AssetAttachmentModel;
  constructor(
    AssetAttachments: Array<AssetAttachmentModel>,
    selectedIndex: number,
    public activeDialogService: UIActiveDialogService
  ) {
    this.attachments = AssetAttachments;
    this.selectedIndex = selectedIndex;
    this.attachment = this.attachments[this.selectedIndex];
  }

  public previous(): void {
    this.selectedIndex =
      this.selectedIndex == 0
        ? this.attachments.length - 1
        : this.selectedIndex - 1;
    this.attachment = this.attachments[this.selectedIndex];
  }

  public next(): void {
    this.selectedIndex =
      this.selectedIndex == this.attachments.length - 1
        ? 0
        : this.selectedIndex + 1;
    this.attachment = this.attachments[this.selectedIndex];
  }

  public onClose(): void {
    this.activeDialogService.dismiss();
  }

  public onDownload(): void {
    window.open(this.attachment.url, '_blank');
  }

  isImageFileExtension = (extension: string): boolean => {
    const imgExtensions: string[] = [
      'PNG',
      'JPEG',
      'GIF',
      'TIFF',
      'JPG',
      'HEIC'
    ];
    return imgExtensions.indexOf(extension.toUpperCase()) > -1;
  };

  parseFileExtensionFromKey = (key: string) => {
    if (!key) {
      return '';
    }
    const fileName = key;
    const extension = fileName.substring(fileName.lastIndexOf('.') + 1);
    return extension ? extension : '';
  };

  public shotThumbnailOrIcon(attachmentKey: string): boolean {
    if (
      this.isImageFileExtension(this.parseFileExtensionFromKey(attachmentKey))
    ) {
      return true;
    } else {
      return false;
    }
  }
}
